import { Box, Skeleton } from '@/ui/primitives';
import type { ReactElement } from 'react';

export const StatusPieCardSkeleton = (): ReactElement => {
  const size = 164;
  const innerSize = 72;
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ position: 'relative', width: size, height: size }}>
        <Skeleton variant="circular" width={size} height={size} />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: innerSize,
            height: innerSize,
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            backgroundColor: 'background.paper',
          }}
        />
      </Box>
    </Box>
  );
};
